export enum ICalType {
  VRBO = 'vrbo',
  HOME_AWAY = 'homeaway',
  TRIP_ADVISOR = 'tripadvisor',
  BOOKING = 'booking',
  OTHER = 'other',
}
